import { EventEmitter, OnInit } from '@angular/core';
var ScoreStepComponent = /** @class */ (function () {
    function ScoreStepComponent() {
        this.nextStepEvent = new EventEmitter();
        this.slots = [
            {
                value: 0,
                color: '#CC0000'
            },
            {
                value: 1,
                color: '#FF0000'
            },
            {
                value: 2,
                color: '#FF5500'
            },
            {
                value: 3,
                color: '#FF7733'
            },
            {
                value: 4,
                color: '#FFAA00'
            },
            {
                value: 5,
                color: '#FFBB33'
            },
            {
                value: 6,
                color: '#33CC99'
            },
            {
                value: 7,
                color: '#5CD6AD'
            },
            {
                value: 8,
                color: '#3377FF'
            },
            {
                value: 9,
                color: '#0055FF'
            },
            {
                value: 10,
                color: '#003399'
            }
        ];
        this.hoverIndex = -1;
    }
    ScoreStepComponent.prototype.ngOnInit = function () {
    };
    ScoreStepComponent.prototype.setScore = function (index) {
        this.score = index;
        this.hoverIndex = -1;
    };
    ScoreStepComponent.prototype.onHover = function (index) {
        this.hoverIndex = index;
    };
    ScoreStepComponent.prototype.nextStep = function () {
        this.nextStepEvent.emit({
            nextStep: 'comment-step',
            score: this.score
        });
    };
    return ScoreStepComponent;
}());
export { ScoreStepComponent };
